import { type FunctionComponent } from 'react';
import { type TestProps } from '@direct-frontend/components/testing';
import { usePreviewQueue } from '#shared/lib/previewWidget';
import { SidePanelLayer } from './components/SidePanelLayer';

export type PreviewSidePanelProps = TestProps;

export const PreviewSidePanel: FunctionComponent<PreviewSidePanelProps> = ({
    'data-testid': dataTestId = 'PreviewSidePanel',
}) => {
    const { layers, setClose } = usePreviewQueue();

    return (
        <>
            {layers.map(({ id, isOpen, data }) => (
                <SidePanelLayer
                    data-testid={`${dataTestId}.${id}`}
                    key={id}
                    previewId={id}
                    isOpen={isOpen}
                    data={data}
                    onClose={setClose}
                />
            ))}
        </>
    );
};
